import React from 'react';
import ContactBanner from '../components/contact-banner';
import Navbar from '../components/Home-navbar';
import './home.scss';
  

function Home() {
  return (

    <div className='App'>
      <header>
        <Navbar />
      </header>
    <div>
      <div className='container'>
<h2>Specializing in:</h2>

<p className='not-found'>We can't find the page you are looking for. Please contact us with any issues you may be experiencing. </p>

</div>

<ContactBanner ></ContactBanner>


</div>

    </div>
  );
};
  
export default Home;